export const getTitle = (text: string | undefined, maxLength: number): string => {
  return text && text.length > maxLength ? text : "";
};
